import React, { useState, useEffect } from 'react';
import Navitem from '../common/navitem';
import { supabase } from './../../supabase';
import './nav.css';
import home from '../../assets/oka.svg';
import star from '../../assets/star.svg';
import notif from '../../assets/notif.svg';
import map from '../../assets/map.svg';
import ticket from '../../assets/ticket.svg';
import navbg from '../../assets/navbg.png';


const Navigation = () => {
    return (
       <footer>
         <nav className='fixedWidth' role="navigation" aria-label="Main navigation" >
            <div className="navBg">
            <img src={navbg} alt="" />
            </div>
            <ul>
            <Navitem
                    style1="asideNav"
                    title="Home"
                    link="/home"
                    icon={home}
                />
            
            <Navitem
                    style1="asideNav"
                    title="Map"
                    link="/map"
                    icon={map}
                />
            <Navitem
                    style1="asideNav"
                    title="Ticket"
                    link="/ticket"
                    icon={ticket}
                />
                <Navitem
                    style1="asideNav"
                    title="Notifications"
                    link="/notifications"
                    icon={notif}
                />
        </ul>
        </nav>
       </footer>
    );
};

export default Navigation;